import { NavDropdown } from "react-bootstrap";
import { useAuthContext } from "../../../auth/AuthContext";
import StyledNavDropdown from "./StyledNavDropdown";
import { useNavigate } from "react-router-dom";
import LicenceModal from "../../../modal/License/LicenseModal";
import { useState } from "react";
import { Roles } from "../../../../constant/Roles";

interface UserDropdownProps {
  adminEnabled: boolean;
  myLicenceEnabled: boolean;
}

const UserDropdown = ({
  adminEnabled,
  myLicenceEnabled,
}: UserDropdownProps) => {
  const { user, logout } = useAuthContext();
  const isAdmin = user?.roles.includes(Roles.ADMINISTRATOR);
  const navigate = useNavigate();
  const [showLicenseModal, setShowLicenseModal] = useState(false);

  return (
    <>
      <StyledNavDropdown
        title={
          <span className="text-white">
            {user?.firstName} {user?.lastName}
          </span>
        }
        align="end"
      >
        {isAdmin && adminEnabled && (
          <>
            <NavDropdown.Item onClick={() => navigate("/admin")}>
              Admin
            </NavDropdown.Item>
            <NavDropdown.Divider />
          </>
        )}

        {myLicenceEnabled && (
          <NavDropdown.Item onClick={() => setShowLicenseModal(true)}>
            My Licence
          </NavDropdown.Item>
        )}

        <NavDropdown.Item onClick={() => navigate("/my-orders")}>
          My Orders
        </NavDropdown.Item>

        <NavDropdown.Divider />

        <NavDropdown.Item href="/boundaries">Boundaries</NavDropdown.Item>
        <NavDropdown.Item href="/datasets">Datasets</NavDropdown.Item>
        <NavDropdown.Item href="/uk-route-lines">Route Lines</NavDropdown.Item>
        <NavDropdown.Item
          href="https://support.basemap.co.uk/support/login"
          target="_blank"
        >
          Support
        </NavDropdown.Item>

        <NavDropdown.Divider />
        <NavDropdown.Item onClick={() => logout(false)}>
          Logout
        </NavDropdown.Item>
      </StyledNavDropdown>
      <LicenceModal
        show={showLicenseModal}
        onHide={() => setShowLicenseModal(false)}
      />
    </>
  );
};

export default UserDropdown;
